import axiosInstance from './axiosInstance';

let currentStoreId = null;

export const setCurrentStore = (store) => {
  // Use MongoDB _id for the header, not the custom storeId
  currentStoreId = store?._id || store?.id || null;
  
  // Update axios default headers
  if (currentStoreId) {
    axiosInstance.defaults.headers.common['x-storeid'] = currentStoreId;
    // Save to localStorage for persistence across page reloads
    localStorage.setItem('selectedStore', JSON.stringify(store));
    console.log('Store context saved:', currentStoreId);
  } else {
    delete axiosInstance.defaults.headers.common['x-storeid'];
    localStorage.removeItem('selectedStore');
  }
};

export const getCurrentStoreId = () => {
  return currentStoreId;
};

export const getCurrentStore = () => {
  try {
    const storedStore = localStorage.getItem('selectedStore');
    if (storedStore) {
      return JSON.parse(storedStore);
    }
  } catch (e) {
    console.error('Failed to parse stored store:', e);
  }
  return null;
};

export const clearCurrentStore = () => {
  currentStoreId = null;
  delete axiosInstance.defaults.headers.common['x-storeid'];
  localStorage.removeItem('selectedStore');
};

export const restoreStoreContext = () => {
  try {
    const storedStore = localStorage.getItem('selectedStore');
    if (storedStore) {
      const store = JSON.parse(storedStore);
      if (store && store._id) {
        currentStoreId = store._id;
        axiosInstance.defaults.headers.common['x-storeid'] = store._id;
        console.log('Store context restored from localStorage:', store._id);
        return store;
      }
    }
  } catch (e) {
    console.error('Failed to restore store context:', e);
  }
  return null;
};

// Initialize store context with user's first store if available
export const initializeStoreContext = (user) => {
  if (user?.role === 'Owner' && user.stores && user.stores.length > 0) {
    const firstStore = user.stores[0];
    // If firstStore is an ObjectId string, create a store object with _id
    if (typeof firstStore === 'string') {
      const storeObject = { _id: firstStore };
      setCurrentStore(storeObject);
      return storeObject;
    } else {
      // If firstStore is already a store object
      setCurrentStore(firstStore);
      return firstStore;
    }
  }
  return null;
}; 